import { createContext, useContext, useRef, ReactNode } from "react";
import { createPortal } from "react-dom";

interface ToolbarContext {
  toolbarRef: React.RefObject<HTMLDivElement>;
}

export function createToolbar() {
  const ctx = createContext<ToolbarContext | undefined>(undefined);
  // strange magic closure

  /**
   * Component for mounting the toolbar
   * @returns 
   */
  function Toolbar() {
    const toolbarCtx = useContext(ctx);
    return (
      <div ref={toolbarCtx?.toolbarRef} />
    )
  }

  /**
   * Component for mounting the toolbar items 
   * NOTE: the children of this component will be portaled out into the toolbar!
   */
  function Tools({ children }: { children: ReactNode }) {
    const toolbarCtx = useContext(ctx);
    const ref = toolbarCtx?.toolbarRef;
    if (!ref?.current) {
      return <></>
    }
    return (
      <>
        {createPortal(children, ref.current)}
      </>
    );
  }

  function Provider({ children }: { children: ReactNode }) {
    const ref = useRef<HTMLDivElement>(null);
    return (
      <ctx.Provider value={{ toolbarRef: ref }}>
        {children}
      </ctx.Provider>
    );
  }

  return ({ Provider, Toolbar, Tools });
}
